'use client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// components
import PageContainer from '@/app/components/container/PageContainer';
import AuthLogin from '../../authForms/AuthLogin';
import Image from 'next/image';


export default function Login() {
  return (
    <PageContainer title="Login" description="this is Sample page">
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          '&:before': {
            content: '""',
            background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
            backgroundSize: '400% 400%',
            animation: 'gradient 15s ease infinite',
            position: 'absolute',
            height: '100%',
            width: '100%',
            opacity: '0.3',
          },
        }}
      >
        <Grid
          container
          spacing={0}
          justifyContent="center"
          sx={{ minHeight: '100vh',py:5 }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            lg={5}
            xl={4}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              sx={{
                position: 'relative',
                '&:before': {
                  content: "''",
                  position: 'absolute',
                  left: '-125px',
                  bottom: '-100px',
                  width: '200px',
                  height: '200px',
                  borderRadius: '100%',
                  backgroundColor: 'error.main',
                },
                '&:after': {
                  content: "''",
                  position: 'absolute',
                  top: '-65px',
                  right: '-104px',
                  width: '200px',
                  height: '207px',
                  backgroundRepeat: 'no-repeat',
                  background: "url('/images/backgrounds/shap-login.png')",
                  backgroundSize: 'contain',
                },
              }}
            >
              <Card
                elevation={9}
                sx={{
                  p: 4,
                  zIndex: 9,
                  position: 'relative',
                  width: '100%',
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={'0.9rem'}
                      align="center"
                      color={'warning.dark'}
                      ml={2}
                    >
                      <Box
                        component="span"
                        color={'warning.dark'}
                        display={'flex'}
                        alignItems={'center'}
                      >
                      </Box>
                      {/* <CardMedia component="img" src="/images/logos/tfac.png" width={65} alt="TFAC" height={65}/> */}
                      <Image src="/images/logos/tfac.png" width={85} alt="TFAC" height={85} priority quality={100}/>
                      <Typography
                          fontSize={'25px'}
                          lineHeight={'26.4px'}
                          color={'black'}
                        >
                          TFAC : Events Check-in
                        </Typography>
                    </Typography>
                  </Box>
                </Box>
                <AuthLogin
                  subtitle={
                    <Stack
                      direction="row"
                      spacing={1}
                      justifyContent="center"
                      mt={3}
                    >
                    </Stack>
                  }
                />
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
}
